module.exports = __webpack_public_path__ + "static/media/Plans.64c9cefb.png";